import { render, staticRenderFns } from "./Pack.vue?vue&type=template&id=1209b57b&scoped=true&"
import script from "./Pack.vue?vue&type=script&lang=js&"
export * from "./Pack.vue?vue&type=script&lang=js&"
import style0 from "./Pack.vue?vue&type=style&index=0&id=1209b57b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1209b57b",
  null
  
)

export default component.exports